/**
 * Shared components for HomePage (Mobile and Desktop).
 */

import { Link } from "react-router-dom";
import { RESERVED_PATHS } from "../../config/navigation.ts";
import {
  IconAcademicCap,
  IconCalendar,
  IconHeartFilled,
} from "../../components/Icons.tsx";

export function BibleAcademyCard() {
  const cardClass =
    "flex flex-col items-center justify-center gap-1.5 py-3 px-2 rounded-xl bg-white/95 shadow-sm border border-slate-100 active:bg-slate-50 transition-colors no-underline text-inherit min-h-[72px]";

  return (
    <Link
      to="/academy"
      className={cardClass}
      aria-label="Библейская академия жизни"
    >
      <div className="w-9 h-9 rounded-lg bg-amber-50 flex items-center justify-center text-amber-700/80">
        <IconAcademicCap className="w-4 h-4" />
      </div>
      <span className="text-xs font-medium text-slate-700 text-center leading-tight">
        Библейская академия
      </span>
    </Link>
  );
}

export const START_CARD_CLASS =
  "flex flex-col items-center justify-center gap-1.5 py-3 px-2 rounded-xl bg-white/95 shadow-sm border border-slate-100 active:bg-slate-50 transition-colors no-underline text-inherit min-h-[72px]";

export function StartCards() {
  return (
    <>
      <BibleAcademyCard />
      <Link
        to="/schedule"
        className={START_CARD_CLASS}
        aria-label="Афиша мероприятий"
      >
        <div className="w-9 h-9 rounded-lg bg-sky-50 flex items-center justify-center text-sky-700/80">
          <IconCalendar className="w-4 h-4" />
        </div>
        <span className="text-xs font-medium text-slate-700 text-center leading-tight">
          Афиша мероприятий
        </span>
      </Link>
      <Link
        to={RESERVED_PATHS.needPrayer}
        className={START_CARD_CLASS}
        aria-label="Нужна молитва"
      >
        <div className="w-9 h-9 rounded-lg bg-rose-50 flex items-center justify-center text-rose-600/80">
          <IconHeartFilled className="w-4 h-4" />
        </div>
        <span className="text-xs font-medium text-slate-700 text-center leading-tight">
          Нужна молитва
        </span>
      </Link>
    </>
  );
}
